// AUTO-GENERATED — do not edit by hand.
// Regenerar con: ts-node backoffice/migrations/banner/ESPN/logo-vs-logo_sync-visitor-shields.ts
// Cada entrada es `<leagueId>/<shieldFile>` de un escudo que tiene su variante `-visitor.png` en S3.
export const VISITOR_SHIELDS: ReadonlySet<string> = new Set<string>([
  'ligue1/metz',
  'ligue1/o-marseille',
  'ligue1/reims',
  'premier-league/liverpool',
  'premier-league/nottingham-forest',
  'premier-league/tottenham',
  'serie-a/como',
  'serie-a/hellas-verona',
  'serie-a/inter',
  'serie-a/juventus',
  'serie-a/napoli'
]);
